<template>
  <div>
    <slot></slot>
    <div class="crop-stage-program__product-items">
      <a
        v-for="item in products"
        :key="item.id"
        :href="item.url"
        class="crop-stage-program__product-item">
        <!-- image -->
        <div class="crop-stage-program__product-image">
          <responsive-image :images="item.images" />
        </div>
        <!-- content -->
        <div class="crop-stage-program__product-content">
          <div
            class="crop-stage-program__product-title"
            v-html="item.title"></div>
          <div
            class="crop-stage-program__product-amount"
            v-if="item.amount"
            v-html="item.amount"></div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
// components
import ResponsiveImage from '../elements/ResponsiveImage';

export default {
  name: 'crop-stage-products',
  components: {
    ResponsiveImage,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
};
</script>
